import { Component, ElementRef, Input, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService, LocalizedRouterService } from '@pgis/core/services';
import * as _ from 'lodash';
import { User } from '@pgis/shared/models';
// Import navigation elements
import { navigation } from './../../_nav';

@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav" *ngIf="isAuthenticated()">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navigation">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)&&hasModulePermissions(navitem.modulePermissions)">
            <app-sidebar-nav-item [item]="navitem"></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`,
  styleUrls: ['./app-sidebar-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSidebarNavComponent implements OnInit {

  public navigation = navigation;

  constructor(private authenticationService: AuthenticationService,
    private localizedRouter: LocalizedRouterService) { }

  ngOnInit() {
    this.authenticationService.onReauthentication.subscribe(() => {
      //this.cdr.detectChanges();
      const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
      if (!currentUser || !currentUser.firstLogin) {
        //setTimeout(() => {
        //  location.reload();
        //}, 0);
        this.localizedRouter.navigate(['/auth/login']);
      }
      //localStorage.selectedBaseLayers = '[]';
    });
  }
  public isDivider(item) {
    return item.divider ? true : false;
  }

  public isTitle(item) {
    return item.title ? true : false;
  }

  public hasModulePermissions(modulePermissions: string[]) {
    if (!modulePermissions || modulePermissions.length === 0) {
      return true;
    }

    const user = this.authenticationService.getCurrentUser();
    if (modulePermissions.some(mp => user[mp])) {
      return true;
    }

    return _.some(modulePermissions, p => this.authenticationService.userHavePermission(p));
   }

  isAuthenticated() {
    return !_.isEmpty(this.authenticationService.getCurrentUser());
  }
}

import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'" appMobileSidebarToggler>
      <app-sidebar-nav-link [link]="item"></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]="item"></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `,
  styleUrls: ['./app-sidebar-nav.component.scss']
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false;
  }

  public isDropdown() {
    return this.item.children ? true : false;
  }

  public thisUrl() {
    return this.item.url;
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false);
  }

  constructor( private router: Router )  { }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="!isExternalLink() && hasPermissions(link.permissions) && hasModulePermissions(link.modulePermissions)"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url | localize]">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name | translate }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ng-template *ngIf="isExternalLink()">
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name | translate }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
  `,
  styleUrls: ['./app-sidebar-nav.component.scss']
})
export class AppSidebarNavLinkComponent {
  @Input()
  link: any;

  constructor(private authenticationService: AuthenticationService) {}

  public hasVariant() {
    return this.link.variant ? true : false;
  }

  public isBadge() {
    return this.link.badge ? true : false;
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false;
  }

  public isIcon() {
    return this.link.icon ? true : false;
  }

  public hasModulePermissions(modulePermissions: string[]) {
    if (!modulePermissions || modulePermissions.length === 0) {
      return true;
    }

    const user = this.authenticationService.getCurrentUser();
    if (modulePermissions.some(mp => user[mp])) {
      return true;
    }
    return false;
   }

  public hasPermissions(permissions: string[]) {
    if (!permissions || permissions.length === 0) {
      return true;
    }

    return _.some(permissions, p => this.authenticationService.userHavePermission(p));
  }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle pointer" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name | translate }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `,
  styleUrls: ['./app-sidebar-nav.component.scss']
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  constructor(private localizedRouter: LocalizedRouterService,
    private router: Router) { }

  public isBadge() {
    return this.link.badge ? true : false;
  }

  public isIcon() {
    return this.link.icon ? true : false;
  }

  isMapRoute() {
    return this.localizedRouter.isMapRoute() || this.router.url.toLowerCase().indexOf('/dashboard') >= 0;  //map view or object task on map
  }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li);
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];
